export const videoModalDataSet = { cy: 'video-modal' };
